export default {
  DELETED: 'deleted',
  OUTDATED: 'outdated',
  SANCTIONED: 'sanctioned',
  HIRED: 'hired',
  MEETING: 'meeting',
  HIDDEN: 'hidden',
}



// WEBPACK FOOTER //
// ./src/constants/profileStatuses.js